module.exports = __webpack_public_path__ + "static/media/download-android.5230babf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bebanca/download-android.jpg
// module id = 969
// module chunks = 0